import "./styles.scss";

export const IndeterminateLoader = () => {
  return (
    <div className="indeterminate-loader">
      <div className="indeterminate-loader-bar"></div>
    </div>
  );
};
